import * as Yup from "yup";

import {
  EMAIL_REQUIRED_ERROR_MESSAGE,
  INVALID_EMAIL_ERROR_MESSAGE,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MIN_LENGTH_ERROR_MESSAGE,
  PASSWORD_REQUIRED_ERROR_MESSAGE,
} from "@shared/constants";

export type DefaultFieldValues = typeof defaultFieldValues;

export const defaultFieldValues = {
  "create-account": {
    email: "",
    password: "",
  },
  "log-in": {
    email: "",
    password: "",
  },
};

const authValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required(EMAIL_REQUIRED_ERROR_MESSAGE)
    .email(INVALID_EMAIL_ERROR_MESSAGE),
  password: Yup.string()
    .required(PASSWORD_REQUIRED_ERROR_MESSAGE)
    .min(PASSWORD_MIN_LENGTH, PASSWORD_MIN_LENGTH_ERROR_MESSAGE),
});

export const validationSchema = {
  "create-account": authValidationSchema,
  "log-in": authValidationSchema,
};
